export const PermissionValues = {
  globalAdmin: '*.*',
  none: 'none',
  routinespage: {
    read: 'routinespage.read',
  },
  account: {
    all: 'account.*',
    allWorkspace: 'account.*.workspace',
    create: 'account.create',
    invite: 'account.invite',
    update: 'account.update',
    read: 'account.read',
    changeRole: 'account.changeRole',
  },
  activity: {
    all: 'activity.*',
    read: 'activity.read',
  },
  alerts: {
    all: 'workflow.*',
    create: 'workflow.create',
  },
  asset: {
    all: 'asset.*',
    read: 'asset.read',
    create: 'asset.create',
    delete: 'asset.delete',
    update: 'asset.update',
  },
  group: {
    all: 'group.*',
    read: 'group.read',
    create: 'group.create',
  },
  feature: {
    all: 'feature.*',
    create: 'feature.create',
  },
  issue: {
    all: 'issue.*',
    create: 'issue.create',
    update: 'issue.update',
  },
  issuemessage: {
    // Posting a message (and, for Side Chat / plan 0022, the SYSTEM_MESSAGE
    // divider + parented replies) goes through the auto-CRUD
    // IssueMessage.create (PermissionProxyService), so `issuemessage.create` is
    // the effective gate the create resolver requires. Gate the per-row Side
    // chat trigger + pill on this so the UI never offers a flow the resolver
    // will reject with FORBIDDEN.
    all: 'issuemessage.*',
    create: 'issuemessage.create',
    read: 'issuemessage.read',
  },
  tag: {
    all: 'tag.*',
  },
  tagbatch: {
    all: 'tagbatch.*',
    create: 'tagbatch.create',
  },
  workspace: {
    all: 'workspace.*',
    create: 'workspace.create',
    manageSubscription: 'workspace.manageSubscription',
  },
  product: {
    all: 'product.*',
    read: 'product.read',
    create: 'product.create',
    delete: 'product.delete',
  },
  addon: {
    all: 'addon.*',
    read: 'addon.read',
    create: 'addon.create',
    delete: 'addon.delete',
  },
  filespage: {
    read: 'filespage.read',
  },
  peoplepage: {
    read: 'peoplepage.read',
  },
  grouppage: {
    read: 'grouppage.read',
  },
  campaign: {
    read: 'campaign.read',
    create: 'campaign.create',
    update: 'campaign.update',
    delete: 'campaign.delete',
  },
  call: {
    // Placing a call goes through the auto-CRUD Call.create (PermissionProxyService),
    // so `call.create` is the effective gate the startCall resolver requires.
    // Gate the per-row call trigger on this so the UI never offers a call that
    // the resolver will reject with FORBIDDEN.
    create: 'call.create',
    read: 'call.read',
    update: 'call.update',
  },
};

export const GET_ROLES = `
  query FindRoles {
    findRoles(filter: {
      type: { eq: "ACCOUNT" }
    }) {
      items {
        id
        name
      }
    }
  }
`;
